<template>
  <h1>{{message}}</h1>
</template>

<script>
export default {
  name: 'Dummy',
  data () {
    return {
      message:"Hello World!"
    }
  },
  mounted(){
    (this.message);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dummy.vue